module.exports = __webpack_public_path__ + "static/feature-resume-browser-9e1d02b1f6a247b99631c7e166632422.svg";